import { createSlice } from "@reduxjs/toolkit";

const selectedContactSlice = createSlice({
  name: "selectedContact",
  initialState: {
    contact_id: null,
    contactImageURL: "",
    firstname: "",
    lastname: "",
    emailaddresses: [],
    phonenumbers: [],
    tags: [],
    website: "",
    isFavourite: false,
    notes: "",
    tasks: [],
    meetings: [],
  },
  reducers: {
    setSelectedContact: (state, action) => {
      console.log(action.payload, "Selected contact");

      return { ...state, ...action.payload };
    },
    resetSelectedContact: () => ({
      contact_id: null,
      contactImageURL: "",
      firstname: "",
      lastname: "",
      emailaddresses: [],
      phonenumbers: [],
      tags: [],
      website: "",
      isFavourite: false,
      notes: "",
      tasks: [],
      meetings: [],
    }),
  },
});

export const { setSelectedContact, resetSelectedContact } =
  selectedContactSlice.actions;
export default selectedContactSlice.reducer;
